import { render } from "./ModalVisualizarPosicao.vue?vue&type=template&id=0b4f8ae2&scoped=true"
import script from "./ModalVisualizarPosicao.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarPosicao.vue?vue&type=script&lang=js"

import "./ModalVisualizarPosicao.vue?vue&type=style&index=0&id=0b4f8ae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4f8ae2"]])

export default __exports__